// 統一主題配置 - 將顏色主題和風格樣式結合
export const basicTheme = {
  name: "basic",
  displayName: "基本",
  hasCssFile: false,
  isDark: false,
  colors: {
    // 背景色 - 純白簡潔
    bodyBackground: "#f5f5f5",
    contentBackground: "#ffffff",
    tableBackground: "#ffffff",
    tableHeaderBackground: "#e0e0e0",
    tableRowOddBackground: "#fafafa",
    tableCellHighlight: "#f5f5f5",
    modalBackground: "#ffffff",

    // 按鈕相關 - 簡單灰色
    buttonBackground: "#e0e0e0",
    buttonHoverBackground: "#cccccc",
    buttonText: "#333333",
    buttonBorder: "#cccccc",
    buttonHoverBorder: "#999999",

    // 導航列 - 淺灰色
    navBackground: "#ffffff",
    navText: "#333333",
    headerBackground: "#f5f5f5",

    // 文字顏色 - 基本黑灰
    primaryText: "#333333",
    secondaryText: "#666666",

    // 邊框 - 淺灰
    borderColor: "#dddddd",
    primaryBorder: "#cccccc",

    // Ant Design 客製化
    antPrimaryColor: "#666666",
    antLinkColor: "#666666",
  },
  styles: {
    // 字體
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "500",

    // 圓角
    borderRadiusSmall: "4px",
    borderRadiusMedium: "6px",
    borderRadiusLarge: "8px",

    // 間距
    spacingXs: "4px",
    spacingS: "8px",
    spacingM: "16px",
    spacingL: "24px",
    spacingXl: "32px",

    // 陰影
    shadowSmall: "0 1px 2px rgba(0, 0, 0, 0.05)",
    shadowMedium: "0 2px 4px rgba(0, 0, 0, 0.08)",
    shadowLarge: "0 4px 8px rgba(0, 0, 0, 0.12)",

    // 邊框
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫
    transitionSpeed: "0.2s",
    transitionEasing: "ease",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "1px",
    hoverShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",

    // 特殊效果
    backdropFilter: "none",
    textShadow: "none",
    boxGlow: "none",
    transformSkew: "none",
  }
};

export const darkTheme = {
  name: "dark",
  displayName: "深色",
  hasCssFile: false,
  isDark: true,
  colors: {
    // 背景色 - 深色系
    bodyBackground: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
    contentBackground: "#2d2d2d",
    tableBackground: "#3a3a3a",
    tableHeaderBackground: "#4a4a4a",
    tableRowOddBackground: "rgba(255, 255, 255, 0.02)",
    tableCellHighlight: "rgba(255, 255, 255, 0.05)",
    modalBackground: "#3a3a3a",

    // 按鈕相關 - 深色系
    buttonBackground: "#5a5a5a",
    buttonHoverBackground: "#777777",
    buttonText: "#ffffff",
    buttonBorder: "#777777",
    buttonHoverBorder: "#999999",

    // 導航列 - 深灰色
    navBackground: "linear-gradient(135deg, #2d2d2d 0%, #4a4a4a 100%)",
    navText: "#e0e0e0",
    headerBackground: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",

    // 文字顏色 - 淺色系適合深色背景
    primaryText: "#e0e0e0",
    secondaryText: "#b0b0b0",

    // 邊框 - 深色調
    borderColor: "#555555",
    primaryBorder: "#777777",

    // Ant Design 客製化 - 灰色系主色
    antPrimaryColor: "#777777",
    antLinkColor: "#999999",
  },
  styles: {
    // 字體 - 未來感
    fontFamily: "'Orbitron', 'Rajdhani', 'Roboto', sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "600",

    // 圓角 - 較少圓角，銳利感
    borderRadiusSmall: "2px",
    borderRadiusMedium: "4px",
    borderRadiusLarge: "6px",

    // 間距 - 較寬敞
    spacingXs: "6px",
    spacingS: "12px",
    spacingM: "20px",
    spacingL: "28px",
    spacingXl: "36px",

    // 陰影 - 發光效果
    shadowSmall: "0 0 8px rgba(100, 200, 255, 0.3)",
    shadowMedium: "0 0 16px rgba(100, 200, 255, 0.4)",
    shadowLarge: "0 0 24px rgba(100, 200, 255, 0.5)",

    // 邊框 - 細線
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫 - 較快
    transitionSpeed: "0.3s",
    transitionEasing: "cubic-bezier(0.4, 0, 0.2, 1)",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "1px",
    hoverShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",

    // 特殊效果
    backdropFilter: "blur(10px)",
    textShadow: "0 0 10px rgba(100, 200, 255, 0.6)",
    boxGlow: "0 0 20px rgba(100, 200, 255, 0.4)",
    transformSkew: "none",
  }
};

export const astraTheme = {
  name: "astra",
  displayName: "星辰藍",
  hasCssFile: true,
  isDark: false,
  colors: {
    // 背景色 - 現代科技感，帶有微妙的漸層
    bodyBackground: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
    contentBackground: "#ffffff",
    tableBackground: "#ffffff",
    tableHeaderBackground: "#f8fafc",
    tableRowOddBackground: "#f8fafc",
    tableCellHighlight: "#e2e8f0",
    modalBackground: "#ffffff",

    // 按鈕相關 - Astra風格，現代科技藍漸層
    buttonBackground: "linear-gradient(135deg, #0066cc 0%, #004499 100%)",
    buttonHoverBackground: "linear-gradient(135deg, #0052a3 0%, #003366 100%)",
    buttonText: "#ffffff",
    buttonBorder: "#0066cc",
    buttonHoverBorder: "#0052a3",

    // 導航列 - 科技感設計
    navBackground: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
    navText: "#1e293b",
    headerBackground: "linear-gradient(135deg, #0066cc 0%, #004499 50%, #003366 100%)",

    // 文字顏色 - 現代深色調
    primaryText: "#1e293b",
    secondaryText: "#475569",

    // 邊框 - 科技感藍色調
    borderColor: "#e2e8f0",
    primaryBorder: "#0066cc",

    // Ant Design 客製化 - Astra科技藍
    antPrimaryColor: "#0066cc",
    antLinkColor: "#0066cc",
  },
  styles: {
    // 字體 - 現代科技字體
    fontFamily: "'SF Pro Display', 'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "600",

    // 圓角 - 科技斜切角設計
    borderRadiusSmall: "0px",
    borderRadiusMedium: "0px",
    borderRadiusLarge: "0px",

    // 斜切變形 - 科技斜切角效果
    transformSkew: "skew(-10deg)",

    // 間距 - 寬敞科技間距
    spacingXs: "6px",
    spacingS: "12px",
    spacingM: "24px",
    spacingL: "36px",
    spacingXl: "48px",

    // 陰影 - 強烈的科技發光效果
    shadowSmall: "0 0 10px rgba(0, 102, 204, 0.4), 0 0 20px rgba(0, 102, 204, 0.2)",
    shadowMedium: "0 0 20px rgba(0, 102, 204, 0.5), 0 0 40px rgba(0, 102, 204, 0.3)",
    shadowLarge: "0 0 30px rgba(0, 102, 204, 0.6), 0 0 60px rgba(0, 102, 204, 0.4)",

    // 邊框 - 科技感設計
    borderWidth: "2px",
    borderStyle: "solid",

    // 動畫 - 流暢科技動畫
    transitionSpeed: "0.25s",
    transitionEasing: "cubic-bezier(0.4, 0, 0.2, 1)",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "1px",
    hoverShadow: "0 4px 10px rgba(2, 116, 190, 0.35)",

    // 特殊效果 - 強烈的科技特效
    backdropFilter: "blur(20px)",
    textShadow: "0 0 10px rgba(0, 102, 204, 0.8), 0 0 20px rgba(0, 102, 204, 0.4)",
    boxGlow: "0 0 30px rgba(0, 102, 204, 0.6), inset 0 0 30px rgba(0, 102, 204, 0.1)",
  }
};

export const cuteTheme = {
  name: "cute",
  displayName: "可愛粉",
  hasCssFile: true,
  isDark: false,
  colors: {
    // 背景色 - 溫暖粉色調，超可愛
    bodyBackground: "linear-gradient(135deg, #fef7ff 0%, #f8f4ff 100%)",
    contentBackground: "#ffffff",
    tableBackground: "#ffffff",
    tableHeaderBackground: "#fce7f3",
    tableRowOddBackground: "#fef7ff",
    tableCellHighlight: "#fce7f3",
    modalBackground: "#ffffff",

    // 按鈕相關 - 可愛粉色系
    buttonBackground: "#ec4899",
    buttonHoverBackground: "#db2777",
    buttonText: "#ffffff",
    buttonBorder: "#ec4899",
    buttonHoverBorder: "#db2777",

    // 導航列 - 夢幻粉色
    navBackground: "linear-gradient(135deg, #ffffff 0%, #fef7ff 100%)",
    navText: "#831843",
    headerBackground: "linear-gradient(135deg, #fef7ff 0%, #fce7f3 100%)",

    // 文字顏色 - 溫暖深粉
    primaryText: "#831843",
    secondaryText: "#be185d",

    // 邊框 - 柔和粉色
    borderColor: "#fce7f3",
    primaryBorder: "#ec4899",

    // Ant Design 客製化 - 可愛粉色
    antPrimaryColor: "#ec4899",
    antLinkColor: "#ec4899",
  },
  styles: {
    // 字體 - 可愛圓潤字體
    fontFamily: "'Nunito', 'Quicksand', 'Comic Neue', cursive",
    fontSizeBase: "15px",
    fontWeightNormal: "400",
    fontWeightBold: "700",

    // 圓角 - 超圓潤可愛
    borderRadiusSmall: "12px",
    borderRadiusMedium: "20px",
    borderRadiusLarge: "28px",

    // 間距 - 寬鬆可愛間距
    spacingXs: "8px",
    spacingS: "16px",
    spacingM: "24px",
    spacingL: "36px",
    spacingXl: "52px",

    // 陰影 - 柔和可愛陰影
    shadowSmall: "0 3px 8px rgba(236, 72, 153, 0.15), 0 2px 4px rgba(236, 72, 153, 0.1)",
    shadowMedium: "0 6px 16px rgba(236, 72, 153, 0.2), 0 4px 8px rgba(236, 72, 153, 0.15)",
    shadowLarge: "0 12px 24px rgba(236, 72, 153, 0.25), 0 8px 16px rgba(236, 72, 153, 0.2)",

    // 邊框 - 圓潤可愛
    borderWidth: "2px",
    borderStyle: "solid",

    // 動畫 - 輕快可愛動畫
    transitionSpeed: "0.4s",
    transitionEasing: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "3px",
    hoverShadow: "0 6px 16px rgba(236, 72, 153, 0.35)",

    // 特殊效果
    backdropFilter: "blur(8px)",
    textShadow: "0 1px 2px rgba(236, 72, 153, 0.3)",
    boxGlow: "0 0 20px rgba(236, 72, 153, 0.3)",
    transformSkew: "none",
  }
};

// 清新綠主題 - 清新自然的綠色系設計
export const greenTheme = {
  name: "green",
  displayName: "清新綠",
  hasCssFile: true,
  isDark: false,
  colors: {
    // 背景色 - 清新綠色調
    bodyBackground: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)",
    contentBackground: "#ffffff",
    tableBackground: "#ffffff",
    tableHeaderBackground: "#d1fae5",
    tableRowOddBackground: "#f0fdf4",
    tableCellHighlight: "#d1fae5",
    modalBackground: "#ffffff",

    // 按鈕相關 - 清新綠色系
    buttonBackground: "#059669",
    buttonHoverBackground: "#047857",
    buttonText: "#ffffff",
    buttonBorder: "#059669",
    buttonHoverBorder: "#047857",

    // 導航列 - 自然清新
    navBackground: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
    navText: "#065f46",
    headerBackground: "linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)",

    // 文字顏色 - 深綠色，自然易讀
    primaryText: "#065f46",
    secondaryText: "#047857",

    // 邊框 - 柔和綠色
    borderColor: "#d1fae5",
    primaryBorder: "#059669",

    // Ant Design 客製化 - 清新綠色
    antPrimaryColor: "#059669",
    antLinkColor: "#059669",
  },
  styles: {
    // 字體 - 自然清新字體
    fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "500",

    // 圓角 - 自然圓潤
    borderRadiusSmall: "6px",
    borderRadiusMedium: "10px",
    borderRadiusLarge: "14px",

    // 間距 - 舒適自然間距
    spacingXs: "4px",
    spacingS: "10px",
    spacingM: "18px",
    spacingL: "28px",
    spacingXl: "40px",

    // 陰影 - 柔和自然陰影
    shadowSmall: "0 2px 4px rgba(5, 150, 105, 0.1), 0 1px 2px rgba(5, 150, 105, 0.06)",
    shadowMedium: "0 4px 8px rgba(5, 150, 105, 0.12), 0 2px 4px rgba(5, 150, 105, 0.08)",
    shadowLarge: "0 8px 16px rgba(5, 150, 105, 0.15), 0 4px 8px rgba(5, 150, 105, 0.1)",

    // 邊框 - 自然風格
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫 - 平滑自然過渡
    transitionSpeed: "0.3s",
    transitionEasing: "ease-in-out",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "2px",
    hoverShadow: "0 6px 16px rgba(5, 150, 105, 0.3)",

    // 特殊效果
    backdropFilter: "blur(4px)",
    textShadow: "none",
    boxGlow: "0 0 15px rgba(5, 150, 105, 0.2)",
    transformSkew: "none",
  }
};

export const illustrationTheme = {
  name: "illustration",
  displayName: "鮮明橘",
  hasCssFile: true,
  isDark: false,
  colors: {
    // 背景色 - 插畫風格明亮背景
    bodyBackground: "linear-gradient(135deg, #e0f2fe 0%, #f3e8ff 50%, #fef3c7 100%)",
    contentBackground: "#ffffff",
    tableBackground: "#ffffff",
    tableHeaderBackground: "#fef3c7",
    tableRowOddBackground: "#f0f9ff",
    tableCellHighlight: "#fef3c7",
    modalBackground: "#ffffff",

    // 按鈕相關 - 插畫風格鮮豔色彩
    buttonBackground: "#f59e0b",
    buttonHoverBackground: "#d97706",
    buttonText: "#ffffff",
    buttonBorder: "#f59e0b",
    buttonHoverBorder: "#d97706",

    // 導航列 - 插畫風格多彩導航
    navBackground: "linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%)",
    navText: "#1e40af",
    headerBackground: "linear-gradient(135deg, #e0f2fe 0%, #fef3c7 100%)",

    // 文字顏色 - 插畫風格深色文字
    primaryText: "#1e40af",
    secondaryText: "#7c3aed",

    // 邊框 - 插畫風格彩色邊框
    borderColor: "#fbbf24",
    primaryBorder: "#f59e0b",

    // Ant Design 客製化 - 插畫風格橙色
    antPrimaryColor: "#f59e0b",
    antLinkColor: "#f59e0b",
  },
  styles: {
    // 字體 - 手寫風格插畫字體
    fontFamily: "'Caveat', 'Kalam', 'Comic Neue', cursive",
    fontSizeBase: "16px",
    fontWeightNormal: "400",
    fontWeightBold: "700",

    // 圓角 - 不規則插畫風格圓角
    borderRadiusSmall: "8px 12px 8px 16px",
    borderRadiusMedium: "16px 24px 16px 20px",
    borderRadiusLarge: "24px 32px 24px 28px",

    // 間距 - 活潑的插畫間距
    spacingXs: "10px",
    spacingS: "18px",
    spacingM: "28px",
    spacingL: "42px",
    spacingXl: "60px",

    // 陰影 - 手繪風格陰影
    shadowSmall: "3px 3px 0px rgba(245, 158, 11, 0.3), 0 2px 4px rgba(245, 158, 11, 0.2)",
    shadowMedium: "5px 5px 0px rgba(245, 158, 11, 0.4), 0 4px 8px rgba(245, 158, 11, 0.3)",
    shadowLarge: "8px 8px 0px rgba(245, 158, 11, 0.5), 0 8px 16px rgba(245, 158, 11, 0.4)",

    // 邊框 - 粗線條插畫風格
    borderWidth: "3px",
    borderStyle: "solid",

    // 動畫 - 活潑的插畫動畫
    transitionSpeed: "0.5s",
    transitionEasing: "cubic-bezier(0.68, -0.55, 0.265, 1.55)",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "3px",
    hoverShadow: "5px 5px 0px rgba(245, 158, 11, 0.5)",

    // 特殊效果
    backdropFilter: "blur(6px)",
    textShadow: "2px 2px 0px rgba(245, 158, 11, 0.4)",
    boxGlow: "0 0 25px rgba(245, 158, 11, 0.4)",
    transformSkew: "none",
  }
};

export const baroqueTheme = {
  name: "baroque",
  displayName: "奢華金",
  hasCssFile: true,
  isDark: true,
  colors: {
    // 背景色 - 奢華深色調，巴洛克風格
    bodyBackground: "linear-gradient(135deg, #1a1a1a 0%, #2d1810 50%, #1a1a1a 100%)",
    contentBackground: "#2d1810",
    tableBackground: "#2d1810",
    tableHeaderBackground: "#3d2518",
    tableRowOddBackground: "#24120a",
    tableCellHighlight: "#3d2518",
    modalBackground: "#2d1810",

    // 按鈕相關 - 金色奢華按鈕
    buttonBackground: "#d4af37",
    buttonHoverBackground: "#b8860b",
    buttonText: "#1a1a1a",
    buttonBorder: "#d4af37",
    buttonHoverBorder: "#b8860b",

    // 導航列 - 深紅色奢華導航
    navBackground: "linear-gradient(135deg, #2d1810 0%, #3d2518 100%)",
    navText: "#f5f5dc",
    headerBackground: "linear-gradient(135deg, #1a1a1a 0%, #2d1810 100%)",

    // 文字顏色 - 金色奢華文字
    primaryText: "#f5f5dc",
    secondaryText: "#d4af37",

    // 邊框 - 金色奢華邊框
    borderColor: "#8b4513",
    primaryBorder: "#d4af37",

    // Ant Design 客製化 - 巴洛克金色
    antPrimaryColor: "#d4af37",
    antLinkColor: "#d4af37",
  },
  styles: {
    // 字體 - 古典華麗字體
    fontFamily: "'Crimson Text', 'Times New Roman', serif",
    fontSizeBase: "16px",
    fontWeightNormal: "400",
    fontWeightBold: "600",

    // 圓角 - 奢華曲線圓角
    borderRadiusSmall: "6px",
    borderRadiusMedium: "12px",
    borderRadiusLarge: "20px",

    // 間距 - 寬敞莊重間距
    spacingXs: "8px",
    spacingS: "16px",
    spacingM: "28px",
    spacingL: "44px",
    spacingXl: "68px",

    // 陰影 - 奢華光影效果
    shadowSmall: "0 2px 8px rgba(212, 175, 55, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
    shadowMedium: "0 6px 20px rgba(212, 175, 55, 0.3), inset 0 2px 0 rgba(255, 255, 255, 0.15)",
    shadowLarge: "0 12px 32px rgba(212, 175, 55, 0.4), inset 0 3px 0 rgba(255, 255, 255, 0.2)",

    // 邊框 - 金色奢華邊框
    borderWidth: "2px",
    borderStyle: "solid",

    // 動畫 - 優雅莊重動畫
    transitionSpeed: "0.6s",
    transitionEasing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "3px",
    hoverShadow: "0 6px 20px rgba(212, 175, 55, 0.5)",

    // 特殊效果
    backdropFilter: "blur(20px)",
    textShadow: "1px 1px 2px rgba(212, 175, 55, 0.5), 0 0 8px rgba(212, 175, 55, 0.3)",
    boxGlow: "0 0 30px rgba(212, 175, 55, 0.4)",
    transformSkew: "none",
  }
};


export const techTheme = {
  name: "tech",
  displayName: "科技藍",
  hasCssFile: false,
  isDark: true,
  backgroundImage: "tech-bg.webp",
  colors: {
    // 背景色 - 半透明深藍，讓背景圖透出來
    bodyBackground: "transparent",
    contentBackground: "rgba(15, 30, 50, 0.92)",
    tableWrapperBackground: "transparent", // 外層不疊色，交給儲存格
    tableBackground: "rgba(30, 62, 98, 0.45)",
    tableHeaderBackground: "rgba(14, 34, 58, 0.94)",
    tableRowOddBackground: "rgba(30, 62, 98, 0.45)", // 與 tableBackground 相同 = 不顯示斑馬紋
    tableRowHoverBackground: "rgba(0, 168, 255, 0.22)",
    tableCellHighlight: "rgba(0, 168, 255, 0.16)",
    modalBackground: "rgba(20, 40, 65, 0.97)",

    // 按鈕相關 - 科技藍
    buttonBackground: "rgba(12, 32, 54, 0.88)",
    buttonHoverBackground: "rgba(0, 120, 200, 0.85)",
    buttonText: "#e6f7ff",
    buttonBorder: "rgba(0, 168, 255, 0.45)",
    buttonHoverBorder: "#00d4ff",

    // 導航列
    navBackground: "rgba(10, 25, 41, 0.95)",
    navText: "#e6f7ff",
    headerBackground: "rgba(10, 25, 41, 0.92)",

    // 文字顏色
    primaryText: "rgba(255, 255, 255, 0.95)",
    secondaryText: "rgba(255, 255, 255, 0.72)",

    // 邊框
    borderColor: "rgba(0, 168, 255, 0.30)",
    primaryBorder: "rgba(0, 168, 255, 0.45)",

    // Ant Design 客製化
    antPrimaryColor: "#00a8ff",
    antLinkColor: "#00d4ff",
  },
  styles: {
    // 字體
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "500",

    // 圓角
    borderRadiusSmall: "4px",
    borderRadiusMedium: "8px",
    borderRadiusLarge: "12px",

    // 間距
    spacingXs: "4px",
    spacingS: "8px",
    spacingM: "16px",
    spacingL: "24px",
    spacingXl: "32px",

    // 陰影
    shadowSmall: "0 1px 3px rgba(0, 0, 0, 0.4)",
    shadowMedium: "0 2px 8px rgba(0, 0, 0, 0.5)",
    shadowLarge: "0 6px 20px rgba(0, 0, 0, 0.6)",

    // 邊框
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫
    transitionSpeed: "0.3s",
    transitionEasing: "ease",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "2px",
    hoverShadow: "0 4px 14px rgba(0, 168, 255, 0.4)",

    // 特殊效果
    backdropFilter: "blur(8px)",
    textShadow: "none",
    boxGlow: "0 0 16px rgba(0, 168, 255, 0.35)",
    transformSkew: "none",
  }
};

export const ecoTheme = {
  name: "eco",
  displayName: "自然綠",
  hasCssFile: false,
  isDark: false,
  backgroundImage: "eco-bg.webp",
  colors: {
    // 背景色 - 半透明白，讓背景圖透出來
    bodyBackground: "transparent",
    contentBackground: "rgba(255, 255, 255, 0.92)",
    tableWrapperBackground: "transparent", // 外層不疊色，交給儲存格
    tableBackground: "rgba(252, 255, 250, 0.66)",
    tableHeaderBackground: "rgba(222, 243, 212, 0.94)",
    tableRowOddBackground: "rgba(252, 255, 250, 0.66)", // 與 tableBackground 相同 = 不顯示斑馬紋
    tableRowHoverBackground: "rgba(82, 196, 26, 0.14)",
    tableCellHighlight: "rgba(82, 196, 26, 0.14)",
    modalBackground: "rgba(255, 255, 255, 0.97)",

    // 按鈕相關 - 自然綠
    buttonBackground: "rgba(238, 250, 232, 0.92)",
    buttonHoverBackground: "rgba(204, 240, 186, 0.95)",
    buttonText: "#1f5c12",
    buttonBorder: "rgba(82, 196, 26, 0.45)",
    buttonHoverBorder: "#52c41a",

    // 導航列
    navBackground: "rgba(255, 255, 255, 0.92)",
    navText: "#1f5c12",
    headerBackground: "rgba(240, 253, 244, 0.92)",

    // 文字顏色
    primaryText: "rgba(0, 0, 0, 0.88)",
    secondaryText: "rgba(45, 95, 30, 0.80)",

    // 邊框
    borderColor: "rgba(82, 196, 26, 0.30)",
    primaryBorder: "rgba(82, 196, 26, 0.45)",

    // Ant Design 客製化
    antPrimaryColor: "#52c41a",
    antLinkColor: "#13c2c2",
  },
  styles: {
    // 字體
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "500",

    // 圓角
    borderRadiusSmall: "4px",
    borderRadiusMedium: "8px",
    borderRadiusLarge: "12px",

    // 間距
    spacingXs: "4px",
    spacingS: "8px",
    spacingM: "16px",
    spacingL: "24px",
    spacingXl: "32px",

    // 陰影
    shadowSmall: "0 1px 2px rgba(45, 95, 30, 0.08)",
    shadowMedium: "0 2px 6px rgba(45, 95, 30, 0.12)",
    shadowLarge: "0 6px 18px rgba(45, 95, 30, 0.18)",

    // 邊框
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫
    transitionSpeed: "0.3s",
    transitionEasing: "ease",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "2px",
    hoverShadow: "0 4px 12px rgba(82, 196, 26, 0.3)",

    // 特殊效果
    backdropFilter: "blur(8px)",
    textShadow: "none",
    boxGlow: "0 0 14px rgba(82, 196, 26, 0.25)",
    transformSkew: "none",
  }
};

export const spaceTheme = {
  name: "space",
  displayName: "星空黑",
  hasCssFile: false,
  isDark: true,
  backgroundImage: "space-bg.webp",
  colors: {
    // 背景色 - 半透明墨黑，讓背景圖透出來
    bodyBackground: "transparent",
    contentBackground: "rgba(26, 23, 21, 0.86)",
    tableWrapperBackground: "transparent", // 外層不疊色，交給儲存格
    tableBackground: "rgba(48, 41, 36, 0.66)",
    tableHeaderBackground: "rgba(30, 25, 21, 0.94)",
    tableRowOddBackground: "rgba(48, 41, 36, 0.66)", // 與 tableBackground 相同 = 不顯示斑馬紋
    tableRowHoverBackground: "rgba(214, 170, 110, 0.16)",
    tableCellHighlight: "rgba(214, 170, 110, 0.18)",
    modalBackground: "rgba(32, 28, 25, 0.97)",

    // 按鈕相關 - 星光藍
    buttonBackground: "rgba(38, 32, 28, 0.88)",
    buttonHoverBackground: "rgba(214, 170, 110, 0.38)",
    buttonText: "#f5e6d0",
    buttonBorder: "rgba(214, 170, 110, 0.40)",
    buttonHoverBorder: "#e8c07a",

    // 導航列
    navBackground: "rgba(18, 16, 14, 0.92)",
    navText: "#f5e6d0",
    headerBackground: "rgba(18, 16, 14, 0.90)",

    // 文字顏色
    primaryText: "rgba(255, 255, 255, 0.92)",
    secondaryText: "rgba(255, 255, 255, 0.70)",

    // 邊框
    borderColor: "rgba(214, 170, 110, 0.26)",
    primaryBorder: "rgba(214, 170, 110, 0.42)",

    // Ant Design 客製化
    antPrimaryColor: "#d9a441",
    antLinkColor: "#e8c07a",
  },
  styles: {
    // 字體
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontSizeBase: "14px",
    fontWeightNormal: "400",
    fontWeightBold: "500",

    // 圓角
    borderRadiusSmall: "4px",
    borderRadiusMedium: "8px",
    borderRadiusLarge: "12px",

    // 間距
    spacingXs: "4px",
    spacingS: "8px",
    spacingM: "16px",
    spacingL: "24px",
    spacingXl: "32px",

    // 陰影
    shadowSmall: "0 1px 3px rgba(0, 0, 0, 0.5)",
    shadowMedium: "0 2px 8px rgba(0, 0, 0, 0.6)",
    shadowLarge: "0 6px 22px rgba(0, 0, 0, 0.7)",

    // 邊框
    borderWidth: "1px",
    borderStyle: "solid",

    // 動畫
    transitionSpeed: "0.3s",
    transitionEasing: "ease",

    // hover 幅度（由 css/button.css 統一套用）
    hoverLift: "2px",
    hoverShadow: "0 4px 14px rgba(214, 170, 110, 0.35)",

    // 特殊效果
    backdropFilter: "blur(8px)",
    textShadow: "none",
    boxGlow: "0 0 16px rgba(214, 170, 110, 0.30)",
    transformSkew: "none",
  }
};

// 主題對照表
export const themes = {
  basic: basicTheme,
  dark: darkTheme,
  astra: astraTheme,
  cute: cuteTheme,
  green: greenTheme,
  illustration: illustrationTheme,
  baroque: baroqueTheme,
  tech: techTheme,
  eco: ecoTheme,
  space: spaceTheme,
};

// 預設主題
export const DEFAULT_THEME = "basic";